import { registerMutation } from '@adornis/baseql/metadata/register.js';
import { GLOBAL_CONTEXT } from '@adornis/users/db/a-roles.js';
import { addRoleToUser, BaseUser, registerUser } from '@adornis/users/db/a-user.js';
import { MatchingRole } from '../roles.js';

export const registerAdminUser = registerMutation({
  operationName: 'registerAdminUser',
  resolve: (baseUser: BaseUser) => async () => {
    const userID = await registerUser({ ...baseUser.toObject() });
    await addRoleToUser(userID, MatchingRole.ADMIN, [GLOBAL_CONTEXT])();
  },
  type: () => Boolean,
  params: [{ name: 'baseUser', type: () => BaseUser }],
});
